// Import the RTK Query methods from the React-specific entry point
import { Paths } from './paths/paths';
import { apiSlice } from './apiSlice';

export const documentUploadSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadAvatar: builder.mutation<{ msg: string }, FormData>({
      query: (data) => ({
        url: Paths.UserAvatar,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useUploadAvatarMutation } = documentUploadSlice;
